module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.opened) ? _c('div', {
    staticClass: "contents full-height-minus-dropdown"
  }, [_c('div', {
    staticClass: "time-selection-columns"
  }, [(_vm.rulesLoaded && _vm.timesLoading) ? _c('div', {
    staticClass: "from-list scroll-height"
  }, [(_vm.timesLoading) ? _vm._l((5), function(n) {
    return _c('list-slot', {
      key: 'fromTimePlaceholder' + n,
      attrs: {
        "placeholder": true
      }
    })
  }) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "multi-time-container",
    class: 'child-blocks-' + _vm.typeDetails.length
  }, _vm._l((_vm.typeDetails), function(type) {
    return (_vm.rulesLoaded && !_vm.timesLoading) ? _c('collapsible-pane', {
      key: 'pane-' + type.id,
      attrs: {
        "identifier": type.id,
        "header-title": type.getDescription(),
        "expanded": type.expanded
      },
      on: {
        "toggle": _vm.handlePaneToggle
      }
    }, [_c('div', {
      staticClass: "from-list adjusted-scroll-height"
    }, _vm._l((type.startTimes), function(timeSlot) {
      return _c('list-slot', {
        key: timeSlot.uniqueId + '-' + type.id,
        attrs: {
          "main-text": _vm.DateService.friendlyTime(timeSlot.time),
          "main-detail": _vm.getFriendlyEndTime(timeSlot.time, type),
          "centralise": true,
          "disabled": timeSlot.isDisabled || !timeSlot.isValid,
          "selected": timeSlot.selected,
          "no-arrow": "true"
        },
        on: {
          "click": function($event) {
            _vm.toggleSelectedStartTime(type, timeSlot)
          }
        }
      })
    }))]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submittable),
      expression: "submittable"
    }],
    staticClass: "width-100 fixed-bottom flex-v-center flex-justify-right padding-v-half bg-main clickable",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_c('span', {
    staticClass: "font-14 padding-r-half"
  }, [_vm._v("Continue")]), _vm._v(" "), _c('svg', {
    staticClass: "padding-r-1-em",
    attrs: {
      "width": "8px",
      "height": "15px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0 L8 7.5 L0 15 L0 13.5 L6.5 7.5 L0 1.5"
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-280eb51d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/multiTimeStage.vue
// module id = 590
// module chunks = 0